import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import qs from "qs";
import kslogo from "../assets/new-logo.png";
import moment from "moment";
import PsSelect from "./PsSelect";

export const CDN_FILE_URL = "https://pstcdn2.blr1.digitaloceanspaces.com/";

// export const BASE_URL = "http://localhost/git/school-admin/api/";
export const BASE_URL = "https://schooladmin.kalvisalai.in/api/";
export const APP_TITLE = "KALVISALAI-SCHOOL ADMIN";
export const APP_STORAGE_KEY_VALUE = "schadm_";
export const SAAS_SITE_URL = "https://school.kalvisalai.in/";

export const KS_LOGO = kslogo;
export const SITE_FILE_DOWNLOAD_DIR = "files_list/";

export const IconMenu = ({ icon, title, to }) => {
  return (
    <Link to={to || "/"}>
      <Card>
        <Card.Body className="text-center p-4 bg-light">{icon}</Card.Body>
        <Card.Footer className="bg-white" style={{ fontSize: "14px" }}>
          {title || ""}
        </Card.Footer>
      </Card>
    </Link>
  );
};

export { PsSelect };

export function capitalizeFirst(str) {
  if (str == "" || str == null || str == " ") {
    return "";
  }

  str = str.toLowerCase();
  //return str.charAt(0).toUpperCase() + str.slice(1);
  return str.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}

export function upperCase(str) {
  if (str == "" || str == null || str == " " || str.length < 1) return "";
  return str.toString().toUpperCase();
}

export function lowerCase(str) {
  if (str == "" || str == null || str == " ") return "";
  return str.toString().toLowerCase();
}

export function formToObject(form) {
  const data = new FormData(form);
  const value = Object.fromEntries(data.entries());
  return value;
}

export function setLs(key, value) {
  localStorage.setItem(APP_STORAGE_KEY_VALUE + key, value);
}

export function getLs(key) {
  return localStorage.getItem(APP_STORAGE_KEY_VALUE + key) || false;
}

export const cdnFileLink = (fielUrl) => {
  try {
    return `${CDN_FILE_URL}${fielUrl}`;
  } catch (er) {}
};

export function findCommonElement(array1, array2) {
  // Loop for array1
  for (let i = 0; i < array1.length; i++) {
    // Loop for array2
    for (let j = 0; j < array2.length; j++) {
      // Compare the element of each and
      // every element from both of the
      // arrays
      if (upperCase(array1[i]) === upperCase(array2[j])) {
        // Return if common element found
        return true;
      }
    }
  }

  // Return if no common element exist
  return false;
}

export function jsonToQuery(params) {
  return qs.stringify(params);
}

export function groupByMultiple(array, f) {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

export function momentDate(value, toFormat = "DD/MMM/YYYY") {
  try {
    if (
      value == "0000-00-00" ||
      value == "" ||
      value == " " ||
      value == null ||
      value == NaN
    ) {
      return "";
    }

    // var d = new Date(value).getTime();
    return moment(value).format(toFormat);
  } catch (error) {
    //console.log(error);
    return "";
  }
}

export const getFileLiveUrl = (item, originalImage = false) => {
  let url = SAAS_SITE_URL + SITE_FILE_DOWNLOAD_DIR;
  if (item && item.Key) url += item.Key;
  else url += item;
  let ext = getFileExtension(url);
  ext = lowerCase(ext);
  if (["png", "jpg", "jpeg", "bmp", "gif"].includes(ext))
    if (!originalImage) url = url.replace("fm", "fm_thumb");
  return url;
};

export function getFileExtension(item) {
  let paths = removeBothSlash(item).split("/");
  let extension = item.substring(item.lastIndexOf("."));
  //let extension = item.split(".").slice(0, -1).join(".");

  return extension.replace(".", "");

  //return fileType;
}

export function removeBothSlash(str) {
  return str.replace(/^\/|\/$/g, "");
}

export const CUSTOM_ICONS = {
  CUB_LOGO: require("../assets/images/cub_logo.png"),
  KALVISALAI_WIDE_LOGO: require("../assets/images/kalvisalai_logo_wide.png"),
  PEACESOFT_LOGO: require("../assets/images/peacesoft_logo.png"),
  CCAVENUE_LOGO: require("../assets/images/ccavenue_logo.png"),
  NO_USER: require("../assets/images/no_user.jpg"),
  PAYMENT_LINKS: require("../assets/images/payment_links.png"),
  NO_IMAGE: require("../assets/images/noimage.png"),
  BELL: require("../assets/mob/bell_full.png"),
  FEES_IMG: require("../assets/mob/fee_512.png"),
  MY_PROFILE_IMG: require("../assets/mob/account.png"),
  HOME_WORK: require("../assets/mob/study.png"),
  ANNOUNCEMENT_IMG: require("../assets/mob/loudspeaker.png"),
  EVENTS_IMG: require("../assets/mob/event.png"),
  CAMPUS_IMG: require("../assets/mob/earth.png"),
  NO_USER_250: require("../assets/images/no_user.jpg"),
  MAN_256: require("../assets/mob/man_256.png"),
  WOMAN_256: require("../assets/mob/woman_256.png"),
  DEFAULT_256: require("../assets/mob/user_black_256.png"),
  POLICY: require("../assets/mob/policy.png"),
  TERMS: require("../assets/mob/terms.png"),
};
export const sleep = (time) =>
  new Promise((resolve) => setTimeout(resolve, time));
